<template>
  <v-main>
    <AppBar />
    <!-- 리스트 없을경우 -->
    <div v-if="items.length === 0" class="pos-center text-center pb-15">
      <Bell/>
      <div class="fs-14 secondary--text mt-3">도착한 알림이 없습니다.</div>
    </div>
    <ul class="list" v-else>
      <li v-for="(item, index) in items" :key="index" :class="{'new':item.checkAlarm !== 'Y'}">
        <div class="item">
          <div class="icon"></div>
          <div class="content" @click="setMemberAlarmCheck(item.alarmNo)">
            <div class="text" v-text="item.content"></div>
            <div class="date" v-text="item.regDt"></div>
          </div>
        </div>
      </li>
    </ul>
  </v-main>
</template>

<script>
import Bell from '@/components/icons/Bell'
import store from '../../store'
export default {
    data: ()=> ({
      selectedItem: 1,
      memberNo: 0,
      vueIcon: require('@/assets/images/common/alarm.svg'),
      items: [], 
      clickAlarmNo: 0,
      updId: ''
    }),
    components: {
        Bell
    },
    created () {
        this.memberNo = this.$store.state.auth.authUser.userKey;
        this.updId = this.$store.state.auth.authUser.userId;
    },
    mounted() {
        this.getMemberAlarmList();
    },
    methods: {
        async getMemberAlarmList () { 
            await store.dispatch('getMemberAlarmList', this.$_payload({'memberNo': this.memberNo}))
                .then(res => {
                if (res.success) {
                    this.items = res.data;
                } else {
                    console.log(res.msg);
                    this.items = [];
                }
                })
                .catch(error => {
                console.error(error);
                this.items = [];
                })
                .finally(() => {})
                },
        async setMemberAlarmCheck (alarmNo) { 
            await store.dispatch('setMemberAlarmCheck', this.$_payload('inData',{
                    userKey: this.memberNo,
                    alarmNo: alarmNo,
                    updId: this.updId
                }))
                .then(res => {
                if (res.success) {
                    this.getMemberAlarmList();
                } else {
                    console.log(res.msg);
                }
                })
                .catch(error => {
                console.error(error);
                })
                .finally(() => {})
                }
    }
}
</script>

<style lang="scss" scoped>
.list{
    padding:0;
    li{
        padding: 18px $container-padding-x 0;
        .item{
            display: flex;
            flex: 1 1 100%;
            border-bottom: 1px solid #E6E8EA;
            justify-content: space-between;
            padding-bottom: 18px;
            .icon{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                overflow: hidden;
                margin-top: 5px;
              background-color: #7260FF;
              background-image: url('~@/assets/images/common/alarm.svg');
              background-repeat: no-repeat;
              background-position: left 7px top 8px;
              background-size: 14px;
            }
            .content{
                width: calc(100% - 42px);
                .date{
                    font-size: 12px;
                    color: #545457;
                    margin-top: 5px;
                }
            }
        }
        &.new{
            background: $color-sub;
        }
        &:last-child{
            .item{
                border-bottom: none;
            }
        }

    }
}

</style>